import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useCampaignStore = create(
  devtools(
    set => ({
      campaignModalOpen: false,
      selectedCampaign: null,
      openCampaignModal: (campaign = null) =>
        set({ campaignModalOpen: true, selectedCampaign: campaign }),
      closeCampaignModal: () =>
        set({ campaignModalOpen: false, selectedCampaign: null })
    }),
    {
      name: "campaign-store"
    }
  )
);
